module.exports = __webpack_public_path__ + "img/star3.446ee803.png";